import { ReactElement, cloneElement, Children } from "react"
import { useLocation } from "react-router-dom"

import { useCurrentSearchParams } from "../../hooks/useCurrentSearchParams"

type TagsWrapperProps = {
	children: ReactElement | ReactElement[]
	className: string
	queryParams: { default: { [key: string]: string | number }; queryRef: string }
}

export const TagsWrapper = ({
	children,
	className = "",
	queryParams,
}: TagsWrapperProps): ReactElement => {
	const [searchParams] = useCurrentSearchParams(queryParams?.default)

	const valueOfQueryParams = queryParams?.queryRef && searchParams[queryParams.queryRef]
	const location = useLocation()

	return (
		<div className={className}>
			{Children.map(children, (child, index) => {
				const newSearchParams = {
					...searchParams,
					[queryParams.queryRef as string]: child.props.id,
				}
				const queryString = Object.entries(newSearchParams)
					.map(
						([key, value]) =>
							`${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`
					)
					.join("&")
				return cloneElement(child, {
					key: index,
					to: `${location.pathname}?${queryString}`,
					isActive: valueOfQueryParams === String(child.props.id),
				})
			})}
		</div>
	)
}
